import JobPostingSerializers from '../serializers/JobPostingSerializers';
import {JobPosting, JobPostingFormData} from '../types/JobPostingsTypes';

import * as api from '../../../../../lib/api/v1/index';
import {ApiResponse, ApiResponseError} from '../../../../../lib/api/v1/types';

export class JobPostingService {
  async get(companyId: string): Promise<ApiResponse<JobPosting[]>> {
    try {
      const response = await api.getJobPostings(companyId);
      const body = await response.json();

      if (response.ok) {
        const companyJobPostings = JobPostingSerializers.toObjects(body);
        return {
          ok: true,
          data: companyJobPostings,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async create(companyId: string, jobPostingFormData: JobPostingFormData): Promise<ApiResponse<JobPosting>> {
    try {
      const response = await api.createJobPosting(companyId, jobPostingFormData);
      const body = await response.json();

      if (response.ok) {
        const createdJobPosting = JobPostingSerializers.toObject(body);
        return {
          ok: true,
          data: createdJobPosting as any,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async publish(companyId: string, jobPostingId: string): Promise<ApiResponse<JobPosting>> {
    try {
      const response = await api.publishJobPosting(companyId, jobPostingId);
      const body = await response.json();

      if (response.ok) {
        const createdJobPosting = JobPostingSerializers.toObject(body);
        return {
          ok: true,
          data: createdJobPosting,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async update(
    companyId: string,
    jobPostingId: string,
    jobPostingFormData: JobPostingFormData
  ): Promise<ApiResponse<JobPosting>> {
    try {
      const response = await api.updateJobPosting(companyId, jobPostingId, jobPostingFormData);
      const body = await response.json();

      if (response.ok) {
        const updatedJobPosting = JobPostingSerializers.toObject(body);
        return {
          ok: true,
          data: updatedJobPosting as any,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async delete(companyId: string, jobPostingId: string) {
    try {
      await api.deleteJobPosting(companyId, jobPostingId);
      return {
        ok: true,
        data: undefined,
        error: undefined,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
  async archive(companyId: string, jobPostingId: string): Promise<ApiResponse<JobPosting>> {
    try {
      const response = await api.archiveJobPosting(companyId, jobPostingId);
      const body = await response.json();

      if (response.ok) {
        const archivedJobPosting = JobPostingSerializers.toObject(body);
        return {
          ok: true,
          data: archivedJobPosting,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
